import Vue from 'vue'
import VueRouter from 'vue-router'
import EmployeeInfo from '../views/EmployeeInfo.vue'
import EmployeeReport from '../views/EmployeeReport.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: EmployeeReport
  },
  {
      path:'/employee', 
      name: 'EmployeeReport', 
      component: EmployeeInfo
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
